import React from 'react'
import Typography from "@mui/material/Typography";
import AnnouncementLayout from '../../layout/Announcements';

const Announcements = () => {
  return (
    <div className="mainDiv">
         <Typography className="heading">Announcements</Typography>
         <AnnouncementLayout />
         </div>
  )
}

export default Announcements
